import { Reveal, SectionHeader } from "../site/Reveal";

const ICON_SIZE = 24;

export default function FeatureGrid({ overline, title, titleEm, items, light = false, testId = "feature-grid" }) {
  const bg = light ? "bg-navy text-ivory" : "bg-ivory";
  return (
    <section data-testid={testId} className={`py-24 lg:py-32 ${bg}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <SectionHeader light={light} overline={overline} title={<>{title} {titleEm && <em className="italic font-medium">{titleEm}</em>}</>} />
        <div className={`mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px rounded-xl overflow-hidden border ${light ? "bg-ivory/10 border-ivory/10" : "bg-navy/10 border-navy/10"}`}>
          {items.map(({ icon: Icon, title: t, text }, i) => (
            <Reveal key={t} delay={(i % 3) * 0.08} className={`group p-10 transition-colors duration-300 ${light ? "bg-navy hover:bg-[#4a5838]" : "bg-cream hover:bg-powder/60"}`}>
              <Icon size={ICON_SIZE} strokeWidth={1.5} className={`${light ? "text-ivory/80" : "text-navy"} transition-transform duration-300 group-hover:-translate-y-1`} />
              <h3 className={`mt-6 font-display text-xl leading-snug ${light ? "text-ivory" : "text-navy"}`}>{t}</h3>
              <p className={`mt-3 text-sm leading-relaxed ${light ? "text-ivory/60" : "text-charcoal/75"}`}>{text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
